import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditProfilePrinters from '../edit/EditProfilePrinters';
import { DialogContent, DialogTitle } from '@mui/material';
import DialogBase from './DialogBase';

class DialogEditProfilePrinters extends React.Component {

  render () {
    const { classes, open, onClose, ...others } = this.props;
    const scrollableTargetId = "dialog-edit-profile-printers";
    return (
      <DialogBase
        open={open}
        onClose={onClose}
      >
        <DialogTitle>Imprimante</DialogTitle>
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <EditProfilePrinters
            scrollableTarget={scrollableTargetId}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
    padding: theme.spacing(0),
  },
});

DialogEditProfilePrinters.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditProfilePrinters);
